<div class="page-not-found-wrapper">
  <div class="page-not-found__image-container">
    <img class="page-not-found__image" src="assets/images/404-cyan.svg" alt="404">
  </div>
  <p class="page-not-found__text">{{ 'PAGE_NOT_FOUND.TITLE' | translate }}<br>{{ 'PAGE_NOT_FOUND.DESCRIPTION' | translate }}</p>
  <a class="page-not-found__link" [routerLink]="homeUrl">{{'COMMON.GO_TO_HOMEPAGE' | translate}}</a>
</div>
